import { FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import {
  ProcessStep,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content/Sections/ProcessStepSection/ProcessStep';
import useMobileLayout from 'Hooks/useMobileLayout';

export const ProcessSteps = ({ collection }) => {
  const isMobile = useMobileLayout();
  if (!collection) {
    return null;
  }
  return (
    <FDStack direction={isMobile ? 'column' : 'row'} spacing={isMobile ? 2 : 4} justifyContent={'center'}>
      {collection.resources().list().map((step) => <ProcessStep resource={step} key={step.id()} />)}
    </FDStack>
  );
};

ProcessSteps.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
};
